import React, { useCallback } from "react";

import { ICellRendererParams } from "@ag-grid-community/core";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./NameCellRenderer.module.scss";

const NameCellRenderer: React.FC<ICellRendererParams> = ({ context, data, value }) => {
  const intl = useIntl();
  const handleNameClick = useCallback(() => {
    context.onView?.(data);
  }, [context, data]);

  const handleButtonClick = useCallback(() => {
    context.onView?.(data);
  }, [context, data]);

  const supportsRecordView = !!context.onView;

  return (
    <div className={styles.container}>
      <span className={styles.valueText} onClick={handleNameClick}>
        {value}
      </span>
      {supportsRecordView && (
        <Button className={styles.viewButton} onClick={handleButtonClick} type="default">
          {intl.formatMessage({
            id: "grid.nameCell.viewRecord",
            defaultMessage: "View",
            description: "Title of the View button in the Name column",
          })}
        </Button>
      )}
    </div>
  );
};

export default NameCellRenderer;
